import { cn } from '@/utils';

const PrimaryButton = ({
  children,
  className,
  activeClassName,
  hoverClassName,
  disabledClassName,
  small,
  medium,
  large,
  xlarge,
  ...props
}) => {
  let sizeCss = '';

  if (small) {
    sizeCss = 'px-2.5 py-1.5 text-xs';
  } else if(medium) {
    sizeCss ='px-3 py-2 text-sm';
  }  else if(large) {
    sizeCss ='px-4 py-2 text-base';
  }  else if(xlarge) {
    sizeCss ='px-xl py-3 text-base';
  }

  let color = '';
  let colorHover = '';
  let colorActive = '';

  return (
    <button
      className={
        cn(
          "button w-full button-variant-2",
          sizeCss,
          className,
          color,
          colorHover, hoverClassName,
          colorActive, activeClassName,
          'disabled:opacity-40 disabled:cursor-not-allowed disabled:pointer-events-none', disabledClassName
        )}
      {...props}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
